import React from 'react';
import {useTranslation} from 'react-i18next';
import useBuildTasksItems from './useBuildTasksItems';
import {CustomIcon} from '@guestapp/ui';
// import ProgressBar from 'components/ProgressBar';
// import SimpleSlider from 'components/SimpleSlider';
import {TaskList} from 'components/TaskList';
import {SlideCustomItem, TaskText, TasksInformation, TasksPanelContainer} from './styled';

function TasksPanel() {
  const {t} = useTranslation();
  const {items, completedTasks} = useBuildTasksItems();

  const sliderItems = React.useMemo(() => {
    return items
      .filter(item => item.active)
      .map((item, index) => {
        return (
          <SlideCustomItem key={index} className="tasks-panel__slide-item">
            {item.completed ? (
              <CustomIcon name="checkFill" color="#fff" size={'16px'} />
            ) : (
              <CustomIcon name="checkboxIcon" color="#fff" size={'16px'} />
            )}
            {/* {item.completed && <CustomIcon name="checkFill" color="#fff" size={'16px'} /> } */}
            {item.label}
          </SlideCustomItem>
        );
      });
  }, [items]);
  const isCompletedTasks = completedTasks === sliderItems.length;
  const taskInformationText = isCompletedTasks
    ? 'all_tasks_completed'
    : 'please_dont_forget_complete_tasks';

  return (
    <TasksPanelContainer isCompletedTasks={isCompletedTasks} className="tasks-panel">
      <TaskText marginBottom="8px" className="tasks-panel__text">
        <span>{completedTasks}</span>/{sliderItems.length} {t('tasks_completed')}
      </TaskText>

      <TasksInformation className="tasks-panel__info">
        {t(taskInformationText)}
      </TasksInformation>
      <TaskList items={sliderItems} />
      {/* <SimpleSlider items={sliderItems} /> */}
      {/* <ProgressBar percentage={percentage} /> */}
    </TasksPanelContainer>
  );
}
// TasksPanel.defaultProps = defaultProps;

export {TasksPanel};
